module.exports = "/assets/75d8ca7b635b14033f962f93b1031e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/A9.png
// module id = 2316
// module chunks = 0